export default "__VITE_ASSET__BoR1HCsB__"